import React from 'react';
import { motion } from 'framer-motion';
interface AnimatedSectionProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  id?: string;
}
export function AnimatedSection({
  children,
  className = '',
  delay = 0,
  id
}: AnimatedSectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-40px'
  }} transition={{
    duration: 0.45,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-8">
      {children}
    </motion.section>;
}